'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeonBox = void 0;
var $ = require("jquery");
var NeonBox = /** @class */ (function () {
    function NeonBox() {
        var key = '.paramNeonBox';
        if ($(key).length > 0) {
            var box = void 0;
            for (var i = 0; i < $(key).length; i++) {
                box = $(key).eq(i);
                box.append(this.neonBar());
            }
        }
    }
    NeonBox.prototype.neonBar = function () {
        var body = '';
        body += '<div class="neon-box__bars">';
        body += '<em class="neon-box__bar"></em>';
        body += '<em class="neon-box__bar"></em>';
        body += '<em class="neon-box__bar"></em>';
        body += '<em class="neon-box__bar"></em>';
        body += '<em class="neon-box__bar"></em>';
        body += '</div>';
        return body;
    };
    return NeonBox;
}());
exports.NeonBox = NeonBox;
exports.default = NeonBox;
